// @flow @format
import React, {PureComponent, type Node} from 'react';
import PropTypes from 'prop-types';
import './FileList.css';

type Props = {
	children?: Node,
	style: Object,
};

class FileList extends PureComponent<Props, void> {
	static propTypes = {
		children: PropTypes.any.isRequired,
		style: PropTypes.object,
	};

	static defaultProps = {
		style: {},
	};

	render() {
		const {children, style} = this.props;
		return (
			<div className="FileList" style={style}>
				{children}
			</div>
		);
	}
}

export default FileList;



// WEBPACK FOOTER //
// ./src/components/FileList/FileList.js